angular.module('pb.core.user', ['ui.router', 'pb.core.crud']);
